import React, { useState, useEffect } from "react";
import axios from "axios";
import Parse from "html-react-parser";
import TOCLoader from "./Loader";
import ReactHelmet from "../../Components/ReactHelmet/ReactHelmet";

const Termsandconditions = () => {
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/toc-page/get`,
    })
      .then((res) => {
        setTerms(res.data.data);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="terms-main">
      <ReactHelmet title="Terms and conditions - Nepali Garden" />
      <div className="container">
        <div className="text-center text-p text-[26px] font-bold">
          <p>
            Terms <span className="text-gray-600">and</span>{" "}
            <span className="text-green">Conditions</span>
          </p>
        </div>
        <div className="terms-body">
          {loading ? (
            <TOCLoader />
          ) : (
            <>
              <h3>{terms[0]?.title}</h3>
              {Parse(terms[0]?.description ? terms[0].description : "")}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Termsandconditions;
